webpackJsonp([201288905897378],{

/***/ 1975:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderPunch","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"clockIn","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"clockOut","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-provider-punch-947455f93a9e9ba77a15.js